import {Stack, Typography} from '@mui/material';
import React from 'react';

import {CustomDivider} from '../styles';
import {defaultVariantProp} from './constants';
import {RowSimpleProps} from './types';

export const Simple = ({
	title,
	dividerSize = 'md',
	value,
	variants = defaultVariantProp,
	color = 'text.primary',
	hiddenDivider = false,
	sx,
}: RowSimpleProps) => (
	<Stack sx={sx}>
		<Typography variant={variants.title} color="text.secondary">
			{title}
		</Typography>
		<Typography variant={variants.value} color={color} sx={{overflowWrap: 'break-word'}}>
			{value}
		</Typography>
		{!hiddenDivider ? <CustomDivider $size={dividerSize} /> : null}
	</Stack>
);
